var storage = {};
export {
  storage as __exports
};
//# sourceMappingURL=storage.js.map
